function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "icon-car_svg__a",
  d: "M25.5 21a1.501 1.501 0 11-1.5 1.501c0-.828.673-1.501 1.5-1.501zm-13 0a1.501 1.501 0 11-1.5 1.501c0-.828.673-1.501 1.5-1.501zM9 25h20v-6H9v6zm3.4-14l13.211.037L27.484 17H10.516l1.884-6zM29 15c-.016 0-.028.008-.044.009l-1.436-4.572C27.262 9.618 26.436 9 25.6 9H12.4c-.836 0-1.662.618-1.92 1.438l-1.436 4.571C9.028 15.008 9.016 15 9 15H7a1 1 0 100 2h1.481l-.002.027C7.644 17.156 7 17.898 7 18.8v6.4c0 .992.777 1.8 1.733 1.8H9v1a1 1 0 001 1h4a1 1 0 001-1v-1h8v1a1 1 0 001 1h4a1 1 0 001-1v-1h.267c.956 0 1.733-.808 1.733-1.8v-6.4c0-.902-.644-1.644-1.479-1.773L29.519 17H31a1 1 0 100-2h-2zM19 36C9.626 36 2 28.374 2 19 2 9.626 9.626 2 19 2c9.374 0 17 7.626 17 17 0 9.374-7.626 17-17 17m0-36C8.507 0 0 8.507 0 19s8.507 19 19 19 19-8.507 19-19S29.493 0 19 0"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "icon-car_svg__b"
}, React.createElement("use", {
  xlinkHref: "#icon-car_svg__a"
})), React.createElement("use", {
  xlinkHref: "#icon-car_svg__a"
}), React.createElement("g", {
  mask: "url(#icon-car_svg__b)"
}, React.createElement("path", {
  d: "M0 0h38v38H0z"
})));

var SvgIconCar = function SvgIconCar(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 38 38",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
};

export default SvgIconCar;